import request from '@/utils/request'


// 查询公司岗位列表
export function listCompanyPost(query) {
  return request({
    url: '/user/company-post/list',
    method: 'get',
    params: query
  })
}

// 查询公司岗位分页
export function pageCompany(query) {
  return request({
    url: '/user/company-post/page',
    method: 'get',
    params: query
  })
}

// 查询公司岗位详细
export function getCompany(data) {
  return request({
    url: '/user/company-post/detail',
    method: 'get',
    params: data
  })
}

// 新增公司岗位
export function addCompany(data) {
  return request({
    url: '/user/company-post/add',
    method: 'post',
    data: data
  })
}

// 修改公司岗位
export function updateCompany(data) {
  return request({
    url: '/user/company-post/edit',
    method: 'post',
    data: data
  })
}

export function syncZfb(data) {
  return request({
    url: '/user/company-post/syncZfb',
    method: 'post',
    data: data
  })
}

// 删除公司岗位
export function delCompany(data) {
  return request({
    url: '/user/company-post/delete',
    method: 'post',
    data: data
  })
}
